module.exports = __webpack_public_path__ + "liya-72a64e6a6948fc439e4b24f47252243c.png";